import React from 'react';

import CollapsibleHelpSection from '../../CollapsibleHelpSection/CollapsibleHelpSection';
import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_I_canXt_upload_my_file,
  TXTWCL_If_your_bank_app_does_not_allo_ELL,
  TXTWCL_My_bank_wonXt_allow_me_to_scre_ELL,
  TXTWCL_My_document_is_in_a_language_o_ELL,
  TXTWCL_There_could_be_several_reasons_ELL,
  TXTWCL_We_accept_a_variety_of_file_fo_ELL,
  TXTWCL_We_prefer_that_documents_are_i_ELL,
  TXTWCL_What_file_formats_are_accepted_ELL,
  TXTWCL_Why_is_my_document_being_rejec_ELL
} from './DepositPaymentVerificationPrompt.messages.json';

interface Props {
  onClose: () => void;
}

const DepositPaymentVerificationPrompt: React.FC<Props> = ({ onClose }) => (
  <Prompt
    title={{ translation: { ...TXTWCL_I_canXt_upload_my_file } }}
    variant="info"
    onClose={onClose}
  >
    <CollapsibleHelpSection
      title={TXTWCL_My_bank_wonXt_allow_me_to_scre_ELL}
      content={TXTWCL_If_your_bank_app_does_not_allo_ELL}
    />
    <CollapsibleHelpSection
      title={TXTWCL_What_file_formats_are_accepted_ELL}
      content={TXTWCL_We_accept_a_variety_of_file_fo_ELL}
    />
    <CollapsibleHelpSection
      title={TXTWCL_Why_is_my_document_being_rejec_ELL}
      content={TXTWCL_There_could_be_several_reasons_ELL}
    />
    <CollapsibleHelpSection
      title={TXTWCL_My_document_is_in_a_language_o_ELL}
      content={TXTWCL_We_prefer_that_documents_are_i_ELL}
    />
  </Prompt>
);

export default DepositPaymentVerificationPrompt;
